import DataTransformPlugin from '@/composables/charts/influx-charts/DataTransformPlugin'

class NightVisionTransformPlugin extends DataTransformPlugin {
  async transformData(series: { data: { x: number; y: number }[] }[]): Promise<unknown> {
    const transformedSeries: { data: { x: number; y: number }[] }[] = []

    series.forEach(seriesElement => {
      if (seriesElement.data.length === 0) {
        transformedSeries.push(seriesElement)
        return
      }
      const transformedSeriesData = []
      let currentStatus = seriesElement.data[0].y
      let currentStartTime = seriesElement.data[0].x
      let currentEndTime = seriesElement.data[0].x

      for (let i = 0; i < seriesElement.data.length; i++) {
        if (seriesElement.data[i].y !== currentStatus) {
          transformedSeriesData.push({
            x: currentStartTime,
            x2: currentEndTime,
            y: 0,
            color: currentStatus ? 'blue' : 'yellow',
          })
          currentStartTime = seriesElement.data[i].x
          currentStatus = seriesElement.data[i].y
        }
        currentEndTime = seriesElement.data[i].x
      }
      transformedSeriesData.push({
        x: currentStartTime,
        x2: currentEndTime,
        y: 0,
        color: currentStatus ? 'blue' : 'yellow',
      })
      transformedSeries.push({ ...seriesElement, data: transformedSeriesData })
    })
    return transformedSeries
  }
}

export default NightVisionTransformPlugin
